import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Immobile, StaticUrls, ImmobileSearch } from '../models';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { MyCookieService } from './my-cookie.service';
import { TokenExpiredService } from './token-expired.service';
import { ImmobileRicercaFlat } from 'app/models/immobile-ricerca-flat';
import { environment } from 'environments/environment';

@Injectable()
export class ImmobiliareService {

	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });
	immobili: Immobile[];
	immobile: Immobile;

	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		@Inject(TokenExpiredService) private tokenExpired: TokenExpiredService) { }

	post(immobile: Immobile): Observable<{ immobile: Immobile, error: boolean }> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._immobile, JSON.stringify(immobile), this.options)
					.map(this.putHandleResponsePostPut);
			}
		}
	}

	postParziale(immobile: Immobile): Observable<{ immobile: Immobile, error: boolean }> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._insertParziale, JSON.stringify(immobile), this.options)
					.map(this.putHandleResponsePostPut);
			}
		}
	}

	put(immobile: Immobile): Observable<{ immobile: Immobile, error: boolean }> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.put(StaticUrls._immobile, JSON.stringify(immobile), this.options)
					.map(this.putHandleResponsePostPut);
			}
		}
	}

	putPubblicato(immobile: Immobile): Observable<{ immobile: Immobile, error: boolean }> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.put(StaticUrls._updatePubblicato, JSON.stringify(immobile), this.options)
					.map(this.putHandleResponsePostPut);
			}
		}
	}

	private putHandleResponsePostPut(response: Response) {
		if (response.status === 200) {
			return { immobile: response.json(), error: false };
		}
		return { immobile: null, error: true };
	}

	updateStato(idImmobile: number): Observable<Response> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.put(StaticUrls._searchImmobileUpdateStato, idImmobile, this.options);
			}
		}
	}

	elimina(idImmobile: number): Observable<Response> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.put(StaticUrls._elimina, idImmobile, this.options);
			}
		}
	}

	cancella(idImmobile: number): Observable<Response> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.put(StaticUrls._cancellazione, idImmobile, this.options);
			}
		}
	}

	updateSospeso(idImmobile: number): Observable<Response> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.put(StaticUrls._searchImmobileUpdateSospeso, idImmobile, this.options);
			}
		}
	}

	private putHandleResponse(response: Response) {
		if (response.status === 200) {
			return { id: response.json(), error: false };
		}
		return { id: null, error: true };
	}

	searchMy(immobile: ImmobileSearch): Observable<Immobile[]> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._getMyImmobili, JSON.stringify(immobile), this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	countMy(immobile: ImmobileSearch): Observable<number> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._countMyImmobili, JSON.stringify(immobile), this.options)
					.map(counter => { return counter.json(); })
					.catch(this.handleError);
			}
		}
	}

	getShort(): Observable<Immobile[]> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.get(StaticUrls._immobileShort, this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	getById(id: string): Observable<Immobile> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.get(StaticUrls._immobile + "/" + id, this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	getByIdShort(id: string): Observable<Immobile> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.get(StaticUrls._immobileShort + "/" + id, this.options)
					.map(this.extractDataObj)
					.catch(this.handleError);
			}
		}
	}

	search(immobile: ImmobileSearch): Observable<Immobile[]> {
		if (this.myCookieService.token) {
			return this.http.post(StaticUrls._searchImmobile, JSON.stringify(immobile), this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	countSearch(immobile: ImmobileSearch): Observable<number> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._countSearchImmobile, JSON.stringify(immobile), this.options)
					.map(counter => { return counter.json(); })
					.catch(this.handleError);
			}
		}
	}

	searchAmministrazione(immobile: ImmobileSearch): Observable<Immobile[]> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._searchImmobileAmministrazione, JSON.stringify(immobile), this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	countSearchAmministrazione(immobile: ImmobileSearch): Observable<number> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._countSearchImmobileAmministrazione, JSON.stringify(immobile), this.options)
					.map(counter => { return counter.json(); })
					.catch(this.handleError);
			}
		}
	}

	aggiungiPreferito(idImmobile: number) {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.put(StaticUrls._saveImmobilePreferito, JSON.stringify(idImmobile), this.options)
					.catch(this.handleError);
			}
		}
	}

	eliminaPreferito(idImmobile: number) {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.delete(StaticUrls._deleteImmobilePreferito + '/' + idImmobile, this.options)
					.catch(this.handleError);
			}
		}
	}

	checkPreferito(idImmobile: number) {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.get(StaticUrls._checkImmobilePreferito + '/' + idImmobile, this.options)
					.catch(this.handleError);
			}
		}
	}

	searchPreferiti(immobile: ImmobileSearch): Observable<Immobile[]> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._getImmobiliPreferiti, JSON.stringify(immobile), this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	countSearchPreferiti(immobile: ImmobileSearch): Observable<number> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.post(StaticUrls._countImmobiliPreferiti, JSON.stringify(immobile), this.options)
					.map(counter => { return counter.json(); })
					.catch(this.handleError);
			}
		}
	}

	getCheck(idImmobile: number): Observable<Array<String>> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.get(StaticUrls._checkImmobile(idImmobile), this.options)
					.map((response: Response) => {
						if (response.status === 200) {
							return null;
						} else if (response.status === 207) {
							return response.json();
						}
					})
					.catch(() => {
						return Observable.throw('UNAUTHORIZED');
					});
			}
		}
	}

	getRicercheSalvate(): Observable<ImmobileRicercaFlat[]> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.get(StaticUrls._ricercheSalvate, this.options)
					.map(this.extractDataRicercaSalvata)
					.catch(this.handleError);
			}
		}
	}

	deleteRicercheSalvate(id: number): Observable<ImmobileRicercaFlat[]> {
		if (this.myCookieService.token) {
			if (tokenNotExpired(environment.tokenName)) {
				return this.http.delete(StaticUrls._deleteRicercheSalvate(id), this.options)
					.catch(this.handleError);
			}
		}
	}

	private extractData(res: Response) {
		this.immobili = res.json();
		return this.immobili;
	}

	private extractDataObj(res: Response) {
		this.immobile = res.json();
		return this.immobile;
	}


	private extractDataRicercaSalvata(res: Response) {
		return res.json();
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/immobiliare.service.ts